<template>
  <div></div>
</template>

<script>
/* eslint-disable */

import { store, mutations } from "../../observable/store";
import {
  generateOrder,
  toPay,
  getWxConfig,
  getOpenid,
} from "@/model/pay/payServer";
import { CacheModule, getAppClient } from "../../utils/commonUtils";

export default {
  data() {
    return {
      wxPay: {
        appid: this.GLOBAL.wxPay.appid, // 测试
        redirectUri: this.GLOBAL.formal
          ? "m.xzjy365.com"
          : "mceshi.xzjy365.com",
      },
      payFlag: 1,
      jsFlag: true,
      orderId:'',
    };
  },
  created() {
    this.payInit(); // 支付初始化
  },
  computed: {
    wxOpendId() {
      return store.openid;
    },
  },
  methods: {
    payInit() {
      let wxHerf = window.location.href;
      let code = wxHerf.split("?")[1] || wxHerf.split("?")[0] || "";
      if (code) {
        let codeArr = code.split("&");
        let codeParam = {};
        for (var i = 0; i < codeArr.length; i++) {
          codeParam[codeArr[i].split("=")[0]] = codeArr[i].split("=")[1];
        }
        if (codeParam.code) {
          this.awitType = false;
          let parmer = {
            appid: this.wxPay.appid, //公众号appid
            code: codeParam.code, //code码
            towDomain: this.wxPay.redirectUri, //域名
          };
          getOpenid(parmer)
            .then((data) => {
              if (data && data.data.openid) {
                mutations.getOpenid(data.data.openid);
              }
            })
            .catch(() => {});
        } else {
          if (store.openid == "0" && getAppClient() == "JSAPI") {
            let url =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
              this.wxPay.appid +
              "&redirect_uri=" +
              encodeURIComponent(location.href) +
              "&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect";
            window.location.replace(url);
          }
        }
      }
      // ------------------------------
      if (getAppClient() == "JSAPI") {
        this.jsFlag = false;
        let data = {
          url: encodeURIComponent(location.href.split("#")[0]),
          appId: this.wxPay.appid,
        };
        getWxConfig(data).then((res) => {
          let data = res.data;
          if (data && data.timeStamp) {
            window.wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: this.wxPay.appid, // 必填，公众号的唯一标识
              timestamp: data.timeStamp, // 必填，生成签名的时间戳
              nonceStr: data.nonce_str, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: [
                "checkJsApi",
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
                "hideMenuItems",
                "chooseImage",
                "uploadImage",
              ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            this.awitType = false;
          }
        });
      }
    },
    goPay() {
      let data = {
        id: this.orderId,
        type: getAppClient() == "JSAPI" ? 3 : this.payFlag * 1, //支付方式 1.微信/2.支付宝
      };
      if (getAppClient() == "JSAPI") {
        data.openid = this.wxOpendId;
      }
      this.ApiNew.Exam.payExamOrder(data).then(res => {
        if (getAppClient() == "JSAPI") {
            // let _this = this;
            let dataTow = res.data;
            wx.ready(function () {
              wx.chooseWXPay({
                timestamp: dataTow.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: dataTow.nonceStr, // 支付签名随机串，不长于 32 位
                package: dataTow.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: dataTow.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: dataTow.paySign, // 支付签名
                success: function () {
                  console.log('支付成功')
                },
                fail: function (res) {
                  console.log("res----", res);
                },
                cancel: function (res) {
                  console.log("支付验证err", res);
                },
              });
            });
            wx.error(function (res) {
              console.log("res失败", res);
            });
          } else {
            window.location.href = res.data.payUrl;
          }
      }).catch(() => {
          alert("支付未知错误,请联系学习规划老师")
          this.awitType = false
        });
    },
  },
};
</script>


<style scoped>
</style>